import * as settings from "../../constants/settings";
import * as priceTypes from "../../constants/priceTypes";
import * as componentTypes from "../../constants/componentTypes";

/**
 * @class PricingTable
 */
export default class PricingTable {
    /**
     * @param {String}  priceDefinition
     * @param {Boolean} localPrices
     * @param {Boolean} priceGroups
     * @param {Boolean} margins
     * @param {Boolean} markups
     * @param {Boolean} discounts
     */
    constructor(priceDefinition, localPrices, priceGroups, margins, markups, discounts) {
        this._purchasePrice = priceDefinition !== settings.SELL_ONLY;
        this._sellPrice = priceDefinition !== settings.PURCHASE_ONLY;
        this._localPrices = localPrices;
        this._priceGroups = priceGroups;
        this._margins = margins;
        this._markups = markups;
        this._discounts = discounts;
        this._columns = [];
        this._marginColumns = [];
        this._editableColumns = [];
    }

    /**
     * @return {Array}
     */
    get columns() {
        return this._columns;
    }

    /**
     * @return {Array}
     */
    get marginColumns() {
        return this._marginColumns;
    }

    /**
     * @return {Array}
     */
    get editableColumns() {
        return this._editableColumns;
    }

    isEditableInput(input, priceData) {
        if (input === componentTypes.COL_PURCHASE_PRICE) {
            return priceData.purchase.editable;
        }

        if (input === componentTypes.COL_SELL_PRICE) {
            return priceData.sell.editable;
        }

        if (input === componentTypes.COL_VAT) {
            return priceData.vat.editable;
        }

        if (input === componentTypes.COL_PRICE_GROUP_PRICE) {
            return priceData.priceGroup.editable && this._priceGroups;
        }

        return true;
    }

    getFirstEditableInput = (priceData) => {
        for (let input of this._editableColumns) {
            if (this.isEditableInput(input, priceData)) {
                return input;
            }
        }

        return null;
    };

    isMarginColumnVisible = (margin) => {
        switch (margin.type) {
            case priceTypes.MARGIN_TYPE_MARGIN:
                return this._margins;
            case priceTypes.MARGIN_TYPE_MARKUP:
                return this._markups;
            case priceTypes.MARGIN_TYPE_DISCOUNT:
                return this._markups;
            default:
                return false;
        }
    };
}
